import { useMemo } from "react";
import { useSpeech } from "react-text-to-speech";
import { Button } from "antd";
import { ReactComponent as Play } from "../assets/icons/Play.svg";
import { ReactComponent as Pause } from "../assets/icons/Pause.svg";
import { ReactComponent as Stop } from "../assets/icons/Stop.svg";
import { ReactComponent as Speaker } from "../assets/icons/Speaker.svg";

export const TextToSpeech = ({ text }) => {
    return null
    const content = useMemo(() => text?.replace(/<[^>]*>/g, ""), [text]);
    const { speechStatus, start, pause, stop } = useSpeech({
        text: content,
    });

    if (!text) return null;

    return (
        <div className="TextSpeech">
            <div><Speaker /> Listen to Audio</div>
            {speechStatus !== "started" ? 
                <Button onClick={start}><Play /> Start</Button> : 
                <Button onClick={pause}><Pause /> Pause</Button>
            }
            <Button onClick={stop}><Stop /> Stop</Button>
        </div>
    );
};
